// import Swal from "sweetalert2";

// const errorAlert = (error) =>{
//   // Verifica si es un error de respuesta del servidor
//   if (error.response) {
//     if (error.response.status === 401) {
//       //alert("Acceso No autorizado: Debe autenticarse.");
//       Swal.fire({
//         title: "Sesión Terminada",
//         text: "Debe volver a autenticarse!",
//         icon: "warning",
//       }).then(() => {
//         // Redirigir al login después de que el usuario cierre la alerta
//         window.location.href = "/auth/signin";
//       });
//       return
//     } else {
//       alert(`Error: ${error.response.status} - ${error.response.data || ''}`);
//     }
//   } else if (error.request) {
//     // La solicitud se hizo pero no se recibió ninguna respuesta
//     alert("No se recibió respuesta del servidor:", error.request);
//   } else {
//     // Algo sucedió al configurar la solicitud que desencadenó un error
//     alert(error);
//   }

// }

// export default errorAlert;

import Swal from "sweetalert2";
import { decryptData } from "../../../src/utils/decrypt"; // ajusta la ruta

const errorAlert = (error) => {
  if (error.response) {
    const { status, data } = error.response;

    let responseData = null;

    // 🔥 Intentar desencriptar correctamente
    try {
      responseData = decryptData({ data });
    } catch (e) {
      console.warn("No se pudo desencriptar, usando data raw");
      responseData = data;
    }

    // =========================
    // 401 - NO AUTORIZADO
    // =========================
    if (status === 401) {
      Swal.fire({
        title: "Sesión Terminada",
        text: "Debe volver a autenticarse!",
        icon: "warning",
      }).then(() => {
        window.location.href = "/auth/signin";
      });
      return;
    }

    // =========================
    // 400 - VALIDACIONES
    // =========================
    if (status === 400) {
      Swal.fire({
        title: "Datos inválidos",
        text:
          responseData?.error ||
          data?.error || // fallback por si no vino encriptado
          "Verifique la información ingresada",
        icon: "warning",
      });
      return;
    }

    // =========================
    // OTROS ERRORES (500, etc)
    // =========================
    Swal.fire({
      title: "Error",
      text:
        responseData?.error ||
        data?.error ||
        `Error ${status}: Ocurrió un problema en el servidor`,
      icon: "error",
    });

  } else if (error.request) {
    Swal.fire({
      title: "Sin conexión",
      text: "No se recibió respuesta del servidor",
      icon: "error",
    });

  } else {
    Swal.fire({
      title: "Error inesperado",
      text: error.message || "Ocurrió un error inesperado",
      icon: "error",
    });
  }
};

export default errorAlert;